import * as React from 'react';
import { useContext } from 'react';
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

import valmetLogo from '../assets/valmet_logo@3x.png';
import LoginForm from './LoginForm';
import ChangePasswordForm from './ChangePasswordForm';
import { AuthContext } from '../store/authContext';

const Login: React.FC = () => {
  const { user } = useContext(AuthContext);

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      sx={{ marginTop: '5rem' }}
    >
      <Grid>
        <Box
          component="img"
          src={valmetLogo}
          alt="Valmet logo"
          sx={{ height: '5rem' }}
        />
      </Grid>
      <Grid>
        <Typography
          sx={(theme) => ({
            color: theme.palette.secondary.main,
            marginTop: '-16px',
          })}
        >
          Valmet Product Tracker
        </Typography>
      </Grid>
      <Grid
        size={{ xl: 8, md: 6, xs: 11 }}
        sx={{ maxWidth: 438, width: '100%' }}
      >
        {user?.challengeName === 'NEW_PASSWORD_REQUIRED' ? (
          <ChangePasswordForm />
        ) : (
          <LoginForm />
        )}
      </Grid>
    </Grid>
  );
};

export default Login;
